<template>
<div>
    <plantVariety-annuity-status-list></plantVariety-annuity-status-list>
</div>
</template>

  
<script>
export default {}
</script>
